import {Injectable} from '@angular/core';
import {InterpolationParameters, TranslateService, Translation} from '@ngx-translate/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable()
export class ExtendedTranslateService extends TranslateService {
  override get(key: string | string[], interpolateParams?: InterpolationParameters): Observable<Translation> {
    return super.get(key, interpolateParams).pipe(
      map((res: Translation) => {
        const postProcessValues = (value: string) => {
          // trim the key
          const trimmedKey = value.trim();

          // check if a context is specified in the key
          const contextSeparator = '!@!';
          const contextSeparatorIndex = trimmedKey.indexOf(contextSeparator);
          if (contextSeparatorIndex === -1) {
            // no context specified
            return trimmedKey;
          }

          // return the value part
          return trimmedKey.substring(contextSeparatorIndex + contextSeparator.length);
        };

        if (typeof res === 'string') {
          return postProcessValues(res);
        }
        if (!res || typeof res !== 'object') {
          return res;
        }

        for (const k in res) {
          if (res.hasOwnProperty(k)) {
            res[k] = postProcessValues(res[k]);
          }
        }
        return res;
      })
    );
  }
}
